// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/cold-weather-altimeter-correction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/cold-weather-altimeter-correction/cold-weather-altimeter-correction.js';
import g1 from '../lessons/meteorology/cold-weather-altimeter-correction/cold-weather-altimeter-direction.js';

mount([g0, g1]);
